import documentReducer from '@redux/slices/document';
import globalReducer from '@redux/slices/global';

const reducer = {
    globalSlice: globalReducer,
    documentSlice: documentReducer,
};

export default reducer;
